import { render, staticRenderFns } from "./addParameter.vue?vue&type=template&id=2251d8c4&"
import script from "./addParameter.vue?vue&type=script&lang=js&"
export * from "./addParameter.vue?vue&type=script&lang=js&"
import style0 from "./addParameter.vue?vue&type=style&index=0&id=2251d8c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports